import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { updateDriverPlanChoice } from "../services/driverOnboardingService";
import logoZuno from "../assets/zuno-logo.png";

export default function PlanoMotorista() {
  const navigate = useNavigate();
  const [planoSelecionado, setPlanoSelecionado] = useState("mensalidade");
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      if (!u) { navigate("/login"); return; }
      setUser(u);
    });
    return () => unsub();
  }, [navigate]);

  const handleConfirmar = async () => {
    if (!user || loading) return;
    setLoading(true);
    try {
      await updateDriverPlanChoice(planoSelecionado);
      navigate("/driver-home");
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  return (
    <div style={s.root}>
      <style>{`
        @keyframes fadeUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
        @keyframes pulse  { 0%,100%{transform:scale(1)} 50%{transform:scale(1.03)} }
        @keyframes orb    { 0%,100%{transform:translate(0,0)} 50%{transform:translate(20px,-15px)} }
        * { box-sizing: border-box; }
      `}</style>

      {/* Background orbs */}
      <div style={{ position:"fixed", inset:0, zIndex:0, overflow:"hidden", pointerEvents:"none" }}>
        <div style={{ position:"absolute", width:400, height:400, borderRadius:"50%", background:"radial-gradient(circle,rgba(124,58,237,0.2) 0%,transparent 70%)", top:-100, left:-100, animation:"orb 10s ease-in-out infinite" }}/>
        <div style={{ position:"absolute", width:300, height:300, borderRadius:"50%", background:"radial-gradient(circle,rgba(245,158,11,0.12) 0%,transparent 70%)", bottom:-80, right:-80, animation:"orb 13s ease-in-out infinite reverse" }}/>
      </div>

      <div style={s.container}>
        {/* Logo */}
        <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:8, animation:"fadeUp 0.4s ease both" }}>
          <img src={logoZuno} alt="Zuno" style={{ height:40, objectFit:"contain" }} />
          <p style={{ fontSize:12, color:"rgba(255,255,255,0.3)", letterSpacing:2, textTransform:"uppercase", margin:0 }}>Escolha seu plano</p>
        </div>

        {/* Título */}
        <div style={{ textAlign:"center", animation:"fadeUp 0.4s ease 0.1s both" }}>
          <h1 style={{ fontSize:24, fontWeight:800, color:"#fff", margin:"0 0 8px", letterSpacing:-0.5 }}>
            Como você quer trabalhar?
          </h1>
          <p style={{ fontSize:14, color:"rgba(255,255,255,0.4)", margin:0, lineHeight:1.6 }}>
            Você pode mudar de plano a qualquer momento
          </p>
        </div>

        {/* Cards dos planos */}
        <div style={{ display:"flex", flexDirection:"column", gap:12, animation:"fadeUp 0.4s ease 0.2s both" }}>

          {/* PLANO MENSALIDADE */}
          <div onClick={() => setPlanoSelecionado("mensalidade")} style={{
            borderRadius:20, padding:"20px", cursor:"pointer", position:"relative",
            background: planoSelecionado === "mensalidade" ? "rgba(124,58,237,0.15)" : "rgba(255,255,255,0.04)",
            border: planoSelecionado === "mensalidade" ? "2px solid rgba(168,85,247,0.7)" : "1.5px solid rgba(255,255,255,0.08)",
            transition:"all 0.25s",
            boxShadow: planoSelecionado === "mensalidade" ? "0 8px 32px rgba(124,58,237,0.2)" : "none",
          }}>
            {/* Badge destaque */}
            <div style={{ position:"absolute", top:-10, right:16, background:"linear-gradient(135deg,#7c3aed,#a855f7)", borderRadius:50, padding:"4px 12px" }}>
              <span style={{ fontSize:11, fontWeight:700, color:"#fff" }}>⭐ MAIS POPULAR</span>
            </div>

            <div style={{ display:"flex", alignItems:"flex-start", gap:14 }}>
              {/* Ícone */}
              <div style={{ width:52, height:52, borderRadius:14, background:"rgba(124,58,237,0.2)", border:"1px solid rgba(168,85,247,0.3)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:24, flexShrink:0 }}>
                💼
              </div>

              <div style={{ flex:1 }}>
                <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4 }}>
                  <h3 style={{ fontSize:17, fontWeight:800, color:"#fff", margin:0 }}>Plano Mensalidade</h3>
                  {planoSelecionado === "mensalidade" && (
                    <div style={{ width:18, height:18, borderRadius:"50%", background:"#a855f7", display:"flex", alignItems:"center", justifyContent:"center" }}>
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    </div>
                  )}
                </div>

                {/* Trial badge */}
                <div style={{ display:"inline-flex", alignItems:"center", gap:5, padding:"3px 10px", borderRadius:50, background:"rgba(34,197,94,0.15)", border:"1px solid rgba(34,197,94,0.3)", marginBottom:12 }}>
                  <div style={{ width:5, height:5, borderRadius:"50%", background:"#22c55e" }} />
                  <span style={{ fontSize:11, fontWeight:700, color:"#22c55e" }}>1 MÊS GRÁTIS para começar</span>
                </div>

                <div style={{ display:"flex", flexDirection:"column", gap:7 }}>
                  {[
                    { icon:"💰", text:"Receba 100% de cada corrida" },
                    { icon:"📅", text:"Mensalidade fixa após o trial" },
                    { icon:"🎁", text:"Bônus por metas diárias e mensais" },
                    { icon:"🔒", text:"Sem taxas por corrida" },
                  ].map((item, i) => (
                    <div key={i} style={{ display:"flex", alignItems:"center", gap:8 }}>
                      <span style={{ fontSize:14 }}>{item.icon}</span>
                      <span style={{ fontSize:13, color:"rgba(255,255,255,0.7)" }}>{item.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* PLANO FLEX */}
          <div onClick={() => setPlanoSelecionado("flex")} style={{
            borderRadius:20, padding:"20px", cursor:"pointer",
            background: planoSelecionado === "flex" ? "rgba(245,158,11,0.12)" : "rgba(255,255,255,0.04)",
            border: planoSelecionado === "flex" ? "2px solid rgba(245,158,11,0.7)" : "1.5px solid rgba(255,255,255,0.08)",
            transition:"all 0.25s",
            boxShadow: planoSelecionado === "flex" ? "0 8px 32px rgba(245,158,11,0.15)" : "none",
          }}>
            <div style={{ display:"flex", alignItems:"flex-start", gap:14 }}>
              {/* Ícone */}
              <div style={{ width:52, height:52, borderRadius:14, background:"rgba(245,158,11,0.15)", border:"1px solid rgba(245,158,11,0.3)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:24, flexShrink:0 }}>
                ⚡
              </div>

              <div style={{ flex:1 }}>
                <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4 }}>
                  <h3 style={{ fontSize:17, fontWeight:800, color:"#fff", margin:0 }}>Plano Flex</h3>
                  {planoSelecionado === "flex" && (
                    <div style={{ width:18, height:18, borderRadius:"50%", background:"#f59e0b", display:"flex", alignItems:"center", justifyContent:"center" }}>
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    </div>
                  )}
                </div>

                <div style={{ display:"inline-flex", alignItems:"center", gap:5, padding:"3px 10px", borderRadius:50, background:"rgba(245,158,11,0.15)", border:"1px solid rgba(245,158,11,0.3)", marginBottom:12 }}>
                  <span style={{ fontSize:11, fontWeight:700, color:"#f59e0b" }}>Sem mensalidade fixa</span>
                </div>

                <div style={{ display:"flex", flexDirection:"column", gap:7 }}>
                  {[
                    { icon:"🆓", text:"Sem mensalidade — comece grátis" },
                    { icon:"📊", text:"Obrigação de 8% por corrida, cobrada separadamente" },
                    { icon:"🗓️", text:"Trabalhe quando quiser" },
                    { icon:"⚡", text:"Ideal para fins de semana" },
                  ].map((item, i) => (
                    <div key={i} style={{ display:"flex", alignItems:"center", gap:8 }}>
                      <span style={{ fontSize:14 }}>{item.icon}</span>
                      <span style={{ fontSize:13, color:"rgba(255,255,255,0.7)" }}>{item.text}</span>
                    </div>
                  ))}
                </div>

                {/* Exemplo visual */}
                <div style={{ marginTop:12, padding:"10px 12px", background:"rgba(245,158,11,0.08)", borderRadius:10, border:"1px solid rgba(245,158,11,0.15)" }}>
                  <p style={{ fontSize:11, color:"rgba(255,255,255,0.4)", margin:"0 0 4px" }}>Exemplo — corrida de R$20,00:</p>
                  <div style={{ display:"flex", justifyContent:"space-between" }}>
                    <span style={{ fontSize:12, color:"rgba(255,255,255,0.6)" }}>Você recebe</span>
                    <span style={{ fontSize:13, fontWeight:700, color:"#f59e0b" }}>R$20,00 (100%)</span>
                  </div>
                  <div style={{ display:"flex", justifyContent:"space-between", marginTop:2 }}>
                    <span style={{ fontSize:12, color:"rgba(255,255,255,0.4)" }}>Taxa Zuno</span>
                    <span style={{ fontSize:12, color:"rgba(255,255,255,0.4)" }}>R$1,60 (8%)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Comparativo rápido */}
        <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:"14px 16px", animation:"fadeUp 0.4s ease 0.3s both" }}>
          <p style={{ fontSize:11, color:"rgba(255,255,255,0.3)", textTransform:"uppercase", letterSpacing:1, margin:"0 0 10px" }}>Comparativo</p>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, textAlign:"center" }}>
            <div style={{ fontSize:12, color:"rgba(255,255,255,0.35)" }}>—</div>
            <div style={{ fontSize:11, fontWeight:700, color:"#a855f7" }}>Mensalidade</div>
            <div style={{ fontSize:11, fontWeight:700, color:"#f59e0b" }}>Flex</div>
            {[
              ["Mensalidade", "Sim (após trial)", "Não"],
              ["Por corrida", "0%", "8%"],
              ["Valor da corrida", "100%", "100%"],
              ["Trial grátis", "30 dias ✓", "—"],
              ["Bônus metas", "✓", "—"],
            ].map(([label, mens, flex], i) => (
              <React.Fragment key={i}>
                <div style={{ fontSize:12, color:"rgba(255,255,255,0.4)", textAlign:"left" }}>{label}</div>
                <div style={{ fontSize:12, color: mens.includes("✓") ? "#22c55e" : "rgba(255,255,255,0.6)" }}>{mens}</div>
                <div style={{ fontSize:12, color: flex.includes("✓") ? "#22c55e" : "rgba(255,255,255,0.6)" }}>{flex}</div>
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Botão confirmar */}
        <button onClick={handleConfirmar} disabled={loading} style={{
          width:"100%", padding:"16px", borderRadius:50, border:"none", cursor: loading ? "not-allowed" : "pointer",
          background: planoSelecionado === "mensalidade"
            ? "linear-gradient(135deg,#7c3aed,#a855f7)"
            : "linear-gradient(135deg,#d97706,#f59e0b)",
          color:"#fff", fontSize:16, fontWeight:700,
          boxShadow: planoSelecionado === "mensalidade" ? "0 10px 30px rgba(124,58,237,0.4)" : "0 10px 30px rgba(245,158,11,0.3)",
          opacity: loading ? 0.7 : 1,
          animation:"fadeUp 0.4s ease 0.35s both",
          display:"flex", alignItems:"center", justifyContent:"center", gap:8,
        }}>
          {loading ? (
            <>
              <div style={{ width:18, height:18, borderRadius:"50%", border:"2px solid rgba(255,255,255,0.3)", borderTopColor:"#fff", animation:"spin 0.8s linear infinite" }} />
              Ativando plano...
            </>
          ) : (
            <>
              {planoSelecionado === "mensalidade" ? "💼 Começar com 1 mês grátis" : "⚡ Começar com Plano Flex"}
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
              </svg>
            </>
          )}
        </button>

        <p style={{ textAlign:"center", fontSize:12, color:"rgba(255,255,255,0.2)", margin:0 }}>
          Você pode trocar de plano a qualquer momento nas configurações
        </p>
      </div>

      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}

const s = {
  root: { minHeight:"100vh", background:"linear-gradient(160deg,#04060f 0%,#080b20 50%,#04060f 100%)", fontFamily:"'Segoe UI', system-ui, sans-serif", position:"relative", overflow:"hidden" },
  container: { position:"relative", zIndex:1, maxWidth:480, margin:"0 auto", padding:"48px 20px 40px", display:"flex", flexDirection:"column", gap:24 },
};
